import Layout from '../views/layout'
import i18n from '@/lang'
import { generateConfigRoute } from '@com/utils/generateConfigRoute'
import PtLayout from '@pt/views/layout/index.vue'

export default {
  path: '/common-setting',
  component: Layout,
  redirect: 'noredirect',
  name: 'common-setting',
  icon: 'set_up',
  meta: {
    title: i18n.t('playTurbo.leftMenu.aside.menu.settings.name'),
  },
  children: [
    generateConfigRoute(
      {
        title: i18n
          .t('playTurbo.leftMenu.aside.menu.accountManagement.profile')
          .toString(),
        pageId: 'user_profile',
      },
      {
        routeConfig: {
          component: PtLayout,
        },
        metaConfig: {
          payment: 'free',
        },
      },
    ),
    {
      path: 'account-auth',
      name: 'common-setting.account-auth',
      component: () => import('../views/pt-entry/common-setting/account-auth'),
      meta: {
        title: i18n.t('playTurbo.authAccount.pageTitle'),
        defaultPath: '/common-setting/account-auth',
        payment: 'free',
      },
    },
    {
      path: 'point-management',
      name: 'common-setting.point-management',
      component: () =>
        import('../views/pt-entry/common-setting/point-management'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.poinitManagement.title'),
        defaultPath: '/common-setting/point-management',
        payment: 'free',
      },
    },
    generateConfigRoute(
      {
        title: i18n
          .t('playTurbo.leftMenu.aside.menu.accountManagement.reset')
          .toString(),
        pageId: 'user_passwd',
      },
      {
        routeConfig: {
          component: PtLayout,
        },
        metaConfig: {
          payment: 'free',
        },
      },
    ),
  ],
}
